import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Navbar.module.css';
import { motion } from 'framer-motion';

const HamburgerNav = () => {
  return (
    <nav>
      <motion.ul className={styles.ul_colapsed}>
        <li className={styles.li_colapsed}>
          <Link className={styles.welcome_nav_text_color} to="/">
            Hem
          </Link>
        </li>
        <li className={styles.li_colapsed}>
          <Link className={styles.project_nav_text_color} to="/projects">
            Projekt
          </Link>
        </li>
        <li className={styles.li_colapsed}>
          <Link className={styles.expertise_nav_text_color} to="/expertise">
            Kunskaper
          </Link>
        </li>
        <li className={styles.li_colapsed}>
          <Link className={styles.about_nav_text_color} to="/about">
            Om
          </Link>
        </li>
        <li className={styles.li_colapsed}>
          <Link className={styles.contact_nav_text_color} to="/contacts">
            Kontakt
          </Link>
        </li>
      </motion.ul>
    </nav>
  );
};

export default HamburgerNav;
